module.exports = __webpack_public_path__ + "static/media/CarlaMedeiros.0bd57103.JPG";